import type { CSSProperties, MouseEvent, ReactElement } from 'react';
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import {
  MAP_SUBSCRIBED_STORAGE_KEY,
  MapOptInContent,
} from '@/components/store/components/MapOptIn/MapOptIn';

import { Backdrop, CloseButton, PopupWrapper } from './PopupBanner.styled';

const STORAGE_KEY = 'popup_teneryfa_mapa_dismissed';
const DELAY_MS = 10_000;

const overlayStyle: CSSProperties = {
  position: 'fixed',
  inset: 0,
  zIndex: 9999,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export const PopupBanner = (): ReactElement | null => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem(STORAGE_KEY)) return;
    if (localStorage.getItem(MAP_SUBSCRIBED_STORAGE_KEY)) return;
    const timer = setTimeout(() => setVisible(true), DELAY_MS);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    document.body.style.overflow = visible ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [visible]);

  useEffect(() => {
    if (!visible) return;
    const onKey = (e: KeyboardEvent): void => {
      if (e.key === 'Escape') close();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [visible]);

  const close = (): void => {
    sessionStorage.setItem(STORAGE_KEY, '1');
    setVisible(false);
  };

  const dismiss = (e: MouseEvent): void => {
    e.stopPropagation();
    close();
  };

  if (!visible) return null;

  return createPortal(
    <div style={overlayStyle}>
      <Backdrop />
      <PopupWrapper>
        <CloseButton aria-label="Zamknij" onClick={dismiss}>
          ✕
        </CloseButton>
        <MapOptInContent compact headingLevel="h2" />
      </PopupWrapper>
    </div>,
    document.body,
  );
};
